import { FxmsData } from "../datas/FxData";

/**
 * 이벤트 관리 클래스
 *
 * 개발자 : T/F팀.
 * 개발년월 : 2022.11.
 */
class FxmsEvent {

  constructor(props) { }

  static compMap = new Map(); // 이벤트를 받을것을 요청한 목록
  static valuePeeker = null;
  static alarmReceiver = null;

  /**
   * 리슨너 제거
   * @param {*} id 
   */
  static removeEventListener(id) {
    console.log("FxmsEvent. remove : ", id);
    FxmsEvent.compMap.delete(id);
  }

  /**
   * 이벤트 수신 등록
   * @param {*} id 
   * @param {*} callback 
   */
  static addEventListener(id, callback) {
    console.log("FxmsEvent. add : ", id);
    FxmsEvent.compMap.set(id, callback);
  }

  /**
   * 이벤트를 브로드캐스팅 한다.
   * 
   * @param {*} obj 
   */
  static event(obj) {
    for (let callback of FxmsEvent.compMap.values()) {
      if (callback) {
        callback(obj);
      }
    }
  }

  static loginCallback;
  static setLoginCallback(loginCallback) {
    FxmsEvent.loginCallback = loginCallback;
  }

  static onLogin(isOk, user) {
    // 아래 오류가 발생하네
    // axios.defaults.headers.common['fxmsSessionId'] = localStorage.getItem('FXMS-SESSIONID');
    // Access to XMLHttpRequest at 'http://localhost:8080/fxms/all/102' from origin 'http://localhost:3000' has been blocked by CORS policy: Request header field fxmssessionid is not allowed by Access-Control-Allow-Headers in preflight response.

    if (FxmsEvent.loginCallback) {
      FxmsEvent.loginCallback(isOk, user);
    }
  }

  /**
   * 수집된 값을 실시간 수신하기 위한 클래스를 시작한다.
   */
  static startValuePeeker() {
    if (FxmsEvent.valuePeeker == null) {
      const host = FxmsData.getVarValue("fxms-value-peeker-host", "10.0.1.11");
      const port = FxmsData.getVarValue("fxms-value-peeker-port", 63819);

      console.log("*** FxmsEvent ***  ValuePeeker connecting ", host, port);

      FxmsEvent.valuePeeker = new ValuePeeker(
        host,
        port,
        function (recvObj, e) {
          if (recvObj && recvObj.eventType == "SessionVo") {
            console.log("*** FxmsEvent ***  ValuePeeker connected", host, port, recvObj);
          }
        }
      );
    }
  }

  /**
   * 실시간 수집된 값을 수신하기 위해 요청한다.
   * @param {*} moNo 관리대상번호
   * @param {*} psId 수집값종류
   * @param {*} callback 수신했을때 호출할 함수
   */
  static addValuePeek(moNo, psId, callback) {
    if (FxmsEvent.valuePeeker == null) {
      FxmsEvent.startValuePeeker();
    }
    FxmsEvent.valuePeeker.addPeek(moNo, psId, callback);

    console.log("*** FxmsEvent ***  addPeek", moNo, psId);
  }

  /**
   * 실시간 수집된 값을 수신을 제거한다.
   * 
   * @param {*} moNo 관리대상번호
   * @param {*} psId 수집값종류
   * @param {*} callback 수신했을때 호출할 함수
   */
  static removeValuePeek(moNo, psId, callback) {
    if (FxmsEvent.valuePeeker != null) {
      FxmsEvent.valuePeeker.removePeek(moNo, psId, callback);
    }
  }

  /**
   * 수집된 값을 실시간 수신하기 위한 클래스를 종료한다.
   */
  static stopValuePeeker() {
    if (FxmsEvent.valuePeeker != null) {
      FxmsEvent.valuePeeker.close();
      FxmsEvent.valuePeeker = null;
      console.log("*** FxmsEvent ***  stopValuePeeker");
    }
  }

  /**
   * 발생된 알람을 실시간 수신하는 클래스를 실행한다.
   * @returns 
   */
  static startAlarmReceiver() {

    if (FxmsEvent.alarmReceiver != null) {
      return;
    }

    const host = FxmsData.getVarValue(
      "fxms-alarm-broadcaster-host",
      "10.0.1.11"
    );
    const port = FxmsData.getVarValue("fxms-alarm-broadcaster-port", 63819);

    console.log("*** FxmsEvent ***  AlarmReceiver connecting ", host, port);
    const alarmReceiver = new AlarmReceiver(
      host,
      port
    );

    if (alarmReceiver.connect()) {
      FxmsEvent.alarmReceiver = alarmReceiver;
    }
  }

  /**
   * 실시간으로 알람을 수신하기 위해 등록한다.
   * 
   * @param {*} callback 알람이 수신되면 호출되는 함수
   * @param {*} id 구분ID
   */
  static addAlarmListener(callback, id) {
    if (FxmsEvent.alarmReceiver == null) {
      FxmsEvent.startAlarmReceiver();
    }
    FxmsEvent.alarmReceiver.addCallback(callback);

    console.log("*** FxmsEvent ***  addAlarmListener", id);
  }

  /**
   * 발생된 알람을 실시간 수신하는 클래스를 종료한다.
   */
  static stopAlarmReceiver() {
    if (FxmsEvent.alarmReceiver != null) {
      FxmsEvent.alarmReceiver.close();
      FxmsEvent.alarmReceiver = null;
      console.log("*** FxmsEvent ***  stopAlarmReceiver");
    }
  }

  static getAlarmReceiver() {
    return FxmsEvent.alarmReceiver;
  }
}


/**
 * 알람등급을 나타낸다.
 */
class AlarmLevel {

  static CRITICAL = 1;
  static MAJOR = 2;
  static MINOR = 3;
  static WARNING = 4;
  static CLEAR = 9;

  static getName(level) {

    if (level == AlarmLevel.CRITICAL) {
      return "critical";
    } else if (level == AlarmLevel.MAJOR) {
      return "major";
    } else if (level == AlarmLevel.MINOR) {
      return "minor";
    } else if (level == AlarmLevel.WARNING) {
      return "warning";
    } else {
      return "normal";
    }
  }
}



/**
 수집한 값을 실시간으로 엿보는 클래스
  */
class ValuePeeker {

  constructor(host, port, callback) {
    this.ws = null;
    this.reqMap = new Map();
    this.isConnected = false;
    this.toSendJson = []; // 서버에 전달할 내용. 연결되기 전에 들어온 경우 등을 처리한다.
    const THIS = this;

    this.intervalId = setInterval(function () {
      console.log('*** FxmsEvent *** ValuePeeker ', THIS.toSendJson.length);
      if (THIS.isConnected) {
        for (let json of THIS.toSendJson) {
          THIS.ws.send(json);
        }
        THIS.toSendJson = [];
      }
    }, 1000);

    this.open(host, port, callback);
  }

  getValueList(moNo, psId) {
    let item = this.getItem(moNo, psId)
    if (item == null) {
      return null;
    }
    return item.values;
  }


  getItem(moNo, psId) {
    let key = this.getKey(moNo, psId);
    return this.reqMap.get(key);
  }

  makeNewItem(moNo, psId) {

    let key = this.getKey(moNo, psId);
    let item = {};

    item.key = key;
    item.values = [];
    item.callbacks = [];
    this.reqMap.set(key, item);
    return item;
  }

  getKey(moNo, psId) {
    let key = moNo + ':' + psId;
    return key;
  }

  /**
   * 수집된 데이터를 전달하라고 요청한다.
   * @param {number} moNo 
   * @param {string} psId 
   * @param {function} callback 
   */
  addPeek(moNo, psId, callback) {

    if (moNo && psId && callback) {

      let item = this.getItem(moNo, psId)
      if (item == null) {
        item = this.makeNewItem(moNo, psId);
        let sendStr = JSON.stringify({ action: 'add', moNo: moNo, psId: psId });
        if (this.isConnected) {
          this.ws.send(sendStr);
          console.log('*** FxmsEvent *** ValuePeeker  send ', sendStr);

        } else {
          this.toSendJson.push(sendStr);
          console.log('*** FxmsEvent *** ValuePeeker  add ', sendStr);
        }
      }

      // 동일한 callback이면 무시한다.
      for (let cb of item.callbacks) {
        if (cb === callback) {
          console.log('*** FxmsEvent *** ValuePeeker  dup callback ');
          return;
        }
      }
      item.callbacks.push(callback);
    }
  }

  removePeek(moNo, psId, callback) {

    let item = this.getItem(moNo, psId)
    if (item == null) {
      return;
    }

    var sendStr = JSON.stringify({ action: 'remove', moNo: moNo, psId: psId });
    this.toSendJson.push(sendStr);
    console.log('*** FxmsEvent *** ValuePeeker  remove ', sendStr);

  }


  open(host, port, callback) {

    console.log('*** FxmsEvent *** ValuePeeker ' + host + ':' + port, FxmsData.token);

    if (host == null || port == null) {
      alert('연결 정보가 없습니다.');
      this.callback('error', host + ':' + port);
      return;
    }

    var THIS = this;
    var ws = new WebSocket("ws://" + host + ':' + port);
    this.ws = ws;

    // websocket 서버에 연결되면 연결 메시지를 화면에 출력한다.
    ws.onopen = function (e) {
      callback('opened', e);

      var map = { jwt : FxmsData.getJWT() };
      var sendStr = JSON.stringify(map);

      THIS.ws.send(sendStr);
    };

    // websocket 에서 수신한 메시지를 화면에 출력한다.
    ws.onmessage = function (e) {
      var recvObj = JSON.parse(e.data);

      if (recvObj.eventType === 'SessionVo') {
        callback(recvObj, e);
        THIS.isConnected = true;
        return;
      }

      if (recvObj.moNo != undefined) {

        let item = THIS.getItem(recvObj.moNo, recvObj.psId);

        if (item != null) {
          let data = { date: recvObj.date, value: recvObj.value };
          item.values.push(data);
          for (let callback of item.callbacks) {
            callback(recvObj);
          }

          // 보관 데이터가 많으면 삭제한다.
          if (item.values.length > 1000) {
            item.values.splice(0, 1);
          }
        }

      }

    };

    // websocket 세션이 종료되면 화면에 출력한다.
    ws.onclose = function (e) {
      callback('closed', e);
      THIS.isConnected = false;
    }
  }

  close() {
    if (this.ws != null) {
      this.ws.close();
    }

    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}




/**
실시간으로 알람의 발생, 해제를 받는 클래스
 */
class AlarmReceiver {

  /**
   */
  constructor(host, port) {
    this.host = host;
    this.port = port;
    this.isConnected = false;
    this.ws = null;
    this.callbackList = [];
    this.alarmHstList = [];

    // 알람번호 기준으로 알람 정보 보유함.
    this.alarmMap = new Map();

    this.connect(function () {

    });
  }

  addCallback(callback) {
    for (let cb of this.callbackList) {
      if (cb == callback) {
        console.log('*** FxmsEvent *** AlarmReceiver dup callback ');
        return;
      }
    }
    this.callbackList.push(callback);
  }

  /**
  현재 발생된 알람을 가져온다.
   */
  loadAlarm() {
    const THIS = this;
    FxmsData.selectGridData('fxAlAlarm/cur', {}, "alarmNo").then(function (res) {
      THIS.setAlarmList(res.data);
    });
  }

  /**
  알람 목록 설정
   */
  setAlarmList(alarmList) {
    if (alarmList) {
      for (var i = 0; i < alarmList.length; i++) {
        this.addAlarm(alarmList[i]);
      }
    }
  }

  /**
  알람을 맵에 넣거나 맵에서 제거한다.
   */
  addAlarm(alarm, e) {

    if (alarm.rlseDtm === undefined || alarm.rlseDtm === null) {
      alarm.rlseDtm = 0;
    }

    console.log('*** FxmsEvent *** AlarmReceiver ', (alarm.rlseDtm == 0 ? '발생' : '해제') + ' ' + alarm.alarmNo + ' ' + alarm.alarmKey, alarm);

    // 발생
    if (alarm.rlseDtm == 0) {

      // 알람 목록
      this.alarmMap.set(alarm.alarmNo, alarm);

      this.alarmHstList.push(alarm);
      if (this.alarmHstList.length > 100) {
        this.alarmHstList.splice(0, 1);
      }
    }

    // 해제
    else {

      var old = this.alarmMap.get(alarm.alarmNo);
      if (old != null) {
        old.rlseDtm = alarm.rlseDtm;
      }
      this.alarmMap.delete(alarm.alarmNo);

    }

    // 방송한다.
    for (let callback of this.callbackList) {
      callback(alarm, e);
    }

  }

  /**
  입력된 관리대상의 최고 알람 등급을 조회한다.
   */
  getAlarmTopLevel(moNo) {

    var level = AlarmLevel.CLEAR;
    var alarmList = this.getAlarmList(moNo);
    var alarm;
    for (var i = 0; i < alarmList.length; i++) {
      alarm = alarmList[i];
      if (alarm.alarmLevel < level) {
        level = alarm.alarmLevel;
      }
    }

    // console.log("alarm-size=" + alarmList.length + ", alarm-level=" + level);

    return level;
  }

  /**
  입력된 관리대상의 알람을 조회한다.
   */
  getAlarmList(moNo) {

    var list = [];
    var alarmList = this.getAlarmAllList();
    var alarm;
    for (var i = 0; i < alarmList.length; i++) {
      alarm = alarmList[i];
      if (alarm.moNo == moNo) {
        list.push(alarm);
      }
    }

    return list;
  }

  connect() {

    console.log('*** FxmsEvent *** AlarmReceiver ', this.host + ':' + this.port, FxmsData.token);

    if (this.host == null || this.port == null) {
      return false;
    }

    let THIS = this;
    let ws = new WebSocket("ws://" + this.host + ':' + this.port);
    this.ws = ws;

    // websocket 서버에 연결되면 연결 메시지를 화면에 출력한다.
    ws.onopen = function (e) {

      for (let callback of THIS.callbackList) {
        callback('opened', e);
      }

      // 연결 후 로그인 정보를 보낸다.
      var map = { jwt : FxmsData.getJWT() };
      var sendStr = JSON.stringify(map);
      THIS.ws.send(sendStr);

      // 현재 발생된 알람을 가져온다.
      THIS.loadAlarm();

    };

    // websocket 에서 수신한 메시지를 화면에 출력한다.
    ws.onmessage = function (e) {

      var recvObj = JSON.parse(e.data);

      console.log('*** FxmsEvent *** AlarmReceiver ', recvObj);

      if (recvObj.eventType === 'SessionVo') {
        THIS.isConnected = true;
        return;
      }

      if (recvObj.eventType == 'Alarm') {
        THIS.addAlarm(recvObj, e);
      }

    };

    // websocket 세션이 종료되면 화면에 출력한다.
    ws.onclose = function (e) {
      for (let callback of THIS.callbackList) {
        callback('closed', e);
      }

      THIS.isConnected = false;
    }

    return true;
  }

  close() {
    if (this.ws != null) {
      this.ws.close();
    }
  }

  /**
   * 현재 알람 목록을 조회한다.
   */
  getAlarmAllList() {
    return Array.from(this.alarmMap.values());
  }

  getAlarmHstList() {
    return this.alarmHstList;
  }

}

export { FxmsEvent, AlarmLevel };
